export class Audit {

    public id: number;
    public operation: string;
    public propertyName: string;
    public oldValue: string;
    public newValue: string;
    public modifiedBy: string;
    public modifiedAt: string;
    public comments: string;

    constructor(audit: any = {}) {
        this.id = audit.id || 0;
        this.operation = audit.operation || '';
        this.propertyName = audit.propertyName || '';
        this.oldValue = audit.oldValue || '';
        this.newValue = audit.newValue || '';
        this.modifiedBy = audit.modifiedBy || '';
        this.modifiedAt = audit.modifiedAt || '';
        this.comments = audit.comments || '';
    }

}
